import { channelsByPostingMode } from '../releases/plan/rollout/launch/postingModes';
import { SerializedSocialChannel, SocialPlatform } from '../types';

/** How the posts of the picked channels go out (QA finding B11). */
export interface ComposerPostingModes {
  /** Picked channels that post by themselves at their time. */
  auto: SocialPlatform[];
  /** Picked channels that come to the artist as a "post it yourself" reminder. */
  manual: SocialPlatform[];
  /** True when the artist has no channel that posts by itself at all. */
  noneConnected: boolean;
}

/**
 * The picked channels split by their posting mode, in the order of the channel list. A picked
 * platform with no channel row counts as a reminder: the screen never says that a post goes out by
 * itself when it cannot know. Pure.
 */
export function composerPostingModes(
  channels: readonly SerializedSocialChannel[],
  selected: readonly SocialPlatform[]
): ComposerPostingModes {
  const picked = channels.filter((channel) => selected.includes(channel.platform));
  const auto = channelsByPostingMode(picked).auto.map((channel) => channel.platform);
  const listed = channels.map((channel) => channel.platform);
  // The order of the channel list first, then a picked platform with no row.
  const ordered = [
    ...listed.filter((platform) => selected.includes(platform)),
    ...selected.filter((one) => !listed.includes(one)),
  ];
  return {
    auto,
    manual: ordered.filter((platform) => !auto.includes(platform)),
    noneConnected: channelsByPostingMode(channels).auto.length === 0,
  };
}
